var map = {
	"./arrow-right.svg": "3f8a",
	"./close.svg": "1d1b",
	"./daphne.jpg": "1ba4",
	"./delete.svg": "26a0",
	"./denise.jpg": "f290",
	"./edit.svg": "66d5",
	"./erwin.jpg": "fb87",
	"./gj.jpg": "c6a2",
	"./logo-icon.png": "0585",
	"./logo.svg": "1ae4",
	"./lydia.jpg": "d3da",
	"./samuela.jpg": "131f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";